export const mainFunctions = {
  methods: {
    formatThousands(value, decimals = null, houses = 2) {
      let rounded = Math.round(value * 100) / 100;
      if (decimals != null) rounded = parseFloat(rounded).toFixed(houses);
      return rounded
        .toString()
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    buildDateString(value) {
      const theDate = new Date(value);
      const date = theDate.getDate();
      const month = theDate.toLocaleString(this.localDate, { month: "long" });
      const year = theDate.getFullYear();
      return `${date} de <span> ${month} </span> de ${year}`;
    },
  },
};
